import React, { useState } from 'react';
import { ArrowRight, Mail } from 'lucide-react';
import { db, auth } from '../../firebase';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

export function CapitolUpgradePrompt() {
  const [joined, setJoined] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const handleJoin = async () => {
    if (!auth.currentUser) return;
    setLoading(true);
    try {
      // TODO: Replace with Stripe Checkout when billing is live
      const waitlistRef = doc(db, 'waitlist', auth.currentUser.uid);
      await setDoc(waitlistRef, {
         email: auth.currentUser.email,
         module: 'Capitol Edge',
         joinedAt: serverTimestamp()
      }, { merge: true });
      setJoined(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl px-4 py-16 mt-10">
      <div className="oi-card p-8 md:p-12">
        <div className="space-y-6">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-oxblood-50 text-oxblood rounded-md text-xs font-medium uppercase tracking-widest border border-oxblood/20">
            <span className="w-1.5 h-1.5 rounded-full bg-oxblood" />
            Premium Module
          </div>
          
          <h2 className="text-4xl md:text-5xl font-serif font-medium text-ink leading-tight">
            Capitol Edge
          </h2>
          
          <p className="text-lg text-ink-600 max-w-lg">
            Unlock predictive intelligence on how pending congressional legislation will affect publicly traded companies before the market prices it in.
          </p>
          
          <div className="pt-8">
            {joined ? (
              <div className="inline-flex items-center gap-3 px-6 py-4 bg-success-50 text-success-700 rounded-md border border-success-100 font-medium">
                 <Mail className="w-5 h-5" />
                 You're on the waitlist. We'll notify you when Capitol Edge goes live.
              </div>
            ) : (
              <button
                onClick={handleJoin}
                disabled={loading}
                className="bg-oxblood text-paper hover:bg-oxblood-800 px-8 py-4 rounded-md font-medium transition-all inline-flex items-center gap-2 disabled:opacity-50"
              >
                {loading ? "Joining..." : "Join the Waitlist"}
                {!loading && <ArrowRight className="w-4 h-4" />}
              </button>
            )}
          </div>
          <p className="text-xs text-ink-500 font-medium mt-4">
            Early Access invites sent out in waves.
          </p>
        </div>
      </div>
    </div>
  );
}
